import moment from 'moment'
import React from 'react'
import Pagination from 'react-js-pagination'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import AdvancedFilter from '../../Components/AdvancedFilter'
import AdvancedTable from '../../Components/AdvancedTable'
import CreateScheduler from '../../Containers/Scheduler/CreateScheduler'
import DeleteScheduler from '../../Containers/Scheduler/DeleteScheduler'
import SchedulerName from '../../Containers/Scheduler/SchedulerName'
import ModularScheduler from '../../Containers/Scheduler/ModularScheduler'
import SchedulerActions from '../../Redux/SchedulerRedux'

class Scheduler extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'ddd, D MMM YYYY h:mm a'
    this.timeformat = 'h:mm:ss a'
    this.state = {
      showModal: null,
      filter: {
        page: 1
      },
      type: '',
      item: {}
    }
  }

  componentDidMount = () => {
    this._fetchScheduler()
  }

  _fetchScheduler = (filter, event) => {
    let data = {}
    if (event) {
      event.preventDefault()
      data = { ...this.state.filter }
      data.page = 1
      this.props.getScheduler(data)
    } else if (!event) {
      if (!filter) {
        data = { ...this.state.filter }
        this.props.getScheduler(data)
      } else if (filter) {
        this.props.getScheduler(filter)
      }
    }
  }

  _selectItem = (modalID, item, type) => {
    this.setState({ item, type })
    this._toggleModal(modalID)
  }

  _toggleModal = (modalID) => {
    if (!modalID) {
      this._fetchScheduler()
    }
    this.setState({ showModal: modalID })
  }

  _determineModal = (item) => {
    let modalID = 'view-ultimate'
    let type = item.product
    if (type !== 'attractions') {
      return (
        <button className='btn btn-info' onClick={() => this._selectItem(modalID, item, type)}>
          <i className='fa fa-book' /> View
        </button>
      )
    }
  }

  _determineProductType = (product) => {
    switch (product) {
      case 'modems':
        return 'Wifi Product'
      case 'banners':
        return 'Banner'
      case 'attractions':
        return 'Attraction'
      default:
        return null
    }
  }

  _editableName = (item) => {
    let value
    if (item.title) {
      value = item.title
    } else {
      value = 'Untitled'
    }
    return (
      <div className='d-flex justify-content-between'>
        <span className='mr-2'>
          {value}
        </span>
        <button className='btn btn-primary btn-sm' onClick={() => this._selectItem('edit-scheduler-title', item)}>
          <i className='fa fa-edit' /> Edit
        </button>
      </div>
    )
  }

  _changePage = (page) => {
    let filter = {
      ...this.state.filter,
      page
    }
    this.setState({ filter })
    this._fetchScheduler(filter)
  }

  _renderPagination = (meta) => {
    return (
      <section className='text-center'>
        {
          (meta && meta.count > 10) &&
          <Pagination
            innerClass='pagination'
            itemClass='page-item'
            linkClass='page-link'
            activePage={meta.page || this.state.filter.page}
            itemsCountPerPage={meta.limit}
            totalItemsCount={meta.count}
            pageRangeDisplayed={5}
            onChange={this._changePage}
          />
        }
      </section>
    )
  }

  _manipulateState = (props) => {
    let filter = { ...this.state.filter }
    filter.q = props.q
    filter.p = props.p
    this.setState({ filter })
  }

  render () {
    const { scheduler } = this.props
    return (
      <section className='section'>
        <header className='title-block d-flex mb-3 justify-content-between'>
          <h1 className='title mr-auto'>
            Manage Scheduler
            {
              (scheduler.fetching || scheduler.processing) &&
              <div className='badge badge-info ml-2'>
                {scheduler.fetching ? 'Loading' : scheduler.processing ? 'Processing' : ''} ...
              </div>
            }
          </h1>
          <button className='btn btn-primary' onClick={() => this._toggleModal('create-scheduler')}>
            <i className='fa fa-plus' /> Create New Scheduler
          </button>
        </header>
        <div className='title-block'>
          <AdvancedFilter
            filters={[
              {
                type: 'text',
                name: 'Title',
                placeholder: 'Search by Title',
                field: 'q'
              },
              {
                type: 'selector',
                name: 'Type',
                field: 'p',
                selectors: [
                  { label: 'ALL', value: '' },
                  { label: 'Wifi Product', value: 'modems' },
                  { label: 'Banner', value: 'banners' },
                  { label: 'Attraction', value: 'attractions' }
                ]
              }
            ]}
            manipulateState={(props) => this._manipulateState(props)}
            callback={(event) => this._fetchScheduler(null, event)}
          />
        </div>
        <AdvancedTable
          colSpan={6}
          header={[
            { field: 'Title' },
            { field: 'Date/Time' },
            { field: 'Type' },
            { field: 'Status' },
            { field: 'Schedule Details' },
            { field: 'Delete' }
          ]}
          body={
            scheduler.data.data &&
            scheduler.data.data.length > 0 &&
            scheduler.data.data.map(item => ([
              { field: this._editableName(item) },
              { field: moment(item.date).format(this.dateformat) },
              { field: this._determineProductType(item.product) },
              { field: item.is_finish === 0 ? 'On Progress' : 'Finished' },
              { field: this._determineModal(item) },
              {
                field: <button className='btn btn-danger' onClick={() => this._selectItem('delete-scheduler', item)}>
                  <i className='fa fa-trash' />
                </button>
              }
            ]))
          }
        />

        { this._renderPagination(scheduler.data.meta) }

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'delete-scheduler'} onClose={() => this._toggleModal(null)}>
          <DeleteScheduler {...this.props} {...this.state.item} closeModal={() => this._toggleModal(null)} />
        </Modal>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-scheduler'} onClose={() => this._toggleModal(null)}>
          <CreateScheduler {...this.props} closeModal={() => this._toggleModal(null)} />
        </Modal>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-ultimate'} onClose={() => this._toggleModal(null)}>
          <ModularScheduler {...this.props} detail={this.state.item} type={this.state.type} closeModal={() => this._toggleModal(null)} />
        </Modal>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-scheduler-title'} onClose={() => this._toggleModal(null)}>
          <SchedulerName {...this.props} detail={this.state.item} closeModal={() => this._toggleModal(null)} />
        </Modal>

      </section>
    )
  }
}

const stateToProps = (state) => ({
  scheduler: state.scheduler,
  product: state.product
})

const dispatchToProps = (dispatch) => ({
  getScheduler: (data) => dispatch(SchedulerActions.getSchedulerRequest(data))
})

export default connect(stateToProps, dispatchToProps)(Scheduler)



// WEBPACK FOOTER //
// ./src/Pages/Misc/Scheduler.js